import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { pricingNote } from "../data/services";

export default function ServiceCard({ service, onView, index = 0 }) {
  return (
    <Reveal delay={(index % 3) * 0.1} className="h-full">
      <article
        className="group flex h-full flex-col border border-line bg-surface transition-shadow duration-500 hover:shadow-[0_24px_60px_-24px_rgba(23,23,23,0.25)]"
        data-testid={`service-card-${service.id}`}
      >
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={service.image}
            alt={service.alt}
            loading="lazy"
            width="800"
            height="600"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 bg-ink/85 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-champagne backdrop-blur-sm">
            {service.category}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-6 md:p-7">
          <h3 className="font-display text-2xl font-medium text-ink">
            {service.name}
          </h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-soften">
            {service.description}
          </p>
          <p className="mt-5 border-t border-line pt-4 text-xs italic text-taupe">
            {service.price ? service.price : pricingNote}
            {service.duration ? ` · ${service.duration}` : ""}
          </p>
          <div className="mt-5 flex items-center gap-5">
            <button
              type="button"
              onClick={() => onView(service)}
              data-testid={`service-view-${service.id}`}
              className="group/btn inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-ink transition-colors hover:text-taupe"
            >
              View Details
              <ArrowUpRight className="h-4 w-4 text-champagne transition-transform duration-300 group-hover/btn:-translate-y-0.5 group-hover/btn:translate-x-0.5" />
            </button>
            <Link
              to={`/book?service=${encodeURIComponent(service.name)}`}
              data-testid={`service-book-${service.id}`}
              className="group/btn inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-ink transition-colors hover:text-taupe"
            >
              Book
              <ArrowRight className="h-4 w-4 text-champagne transition-transform duration-300 group-hover/btn:translate-x-1" />
            </Link>
          </div>
        </div>
      </article>
    </Reveal>
  );
}
